export { Chip } from './Chip';
export type { IChipProps } from '@shared/types';
